<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="17" fill="none"><path d="M20.027.537h-1.732a.785.785 0 0 0-.622.306L7.453 13.97l-4.9-6.295a.795.795 0 0 0-.622-.307H.2a.2.2 0 0 0-.156.325l6.788 8.72a.789.789 0 0 0 1.247 0L20.183.858a.2.2 0 0 0-.156-.321Z"/></svg>
</template>

<script>
export default {
  name: 'icon-check'
}
</script>
